import { ISelectedATE } from 'types/mainPage';

type Ate = ISelectedATE | null;

export const getLastAte = (
  currAteRegion: Ate,
  currAteCity: Ate,
  currAteVC: Ate
) => {
  return (
    (currAteVC?.id && currAteVC) ||
    (currAteCity?.id && currAteCity) ||
    (currAteRegion?.id && currAteRegion)
  );
};
